class Balls {

  constructor() {
    this._isMobile = !window.innerWidth > 500
    this._isStatuspro = window.location.href.includes('statuspro')
    this._page = document.body.getAttribute('data-page-id')
    this._MIN_DATE = {
      month: 11,
      date: 1
    }
    this._MAX_DATE = {
      month: 0,
      date: 20
    }
    this._BELLS_STACK = ['b', 'r', 'w', 'b', 'w', 'rl', 'b', 'w', 'r'];


    $(document).ready(this.documentReady());
  }

  documentReady() {
    // console.clear();
    const dateNow = new Date();
    if ((dateNow.getMonth() >= this._MIN_DATE.month && dateNow.getDate() >= this._MIN_DATE.date) || (dateNow.getMonth() <= this._MAX_DATE.month && dateNow.getDate() <= this._MAX_DATE.date))
      this.addGarland()
  }

  addGarland() {
    const garlandContainer = this.addGarlandContainer();
    const christmasBranch = this.addChristmasBranches(garlandContainer)
    const ballPartsArr = [];

    this.addStyles()

    ballPartsArr.push(...this.fillAllParts(christmasBranch))

    addEventListener('resize', () => {
      ballPartsArr.forEach(ballsPart => {
        ballsPart.remove()
      })
      ballPartsArr.length = 0;
      ballPartsArr.push(...this.fillAllParts(christmasBranch))
    })
  }

  addGarlandContainer() {
    const garlandContainer = document.createElement('div')
    const search = document.getElementsByClassName('search')[0];
    garlandContainer.classList.add('garland-container')
    search.after(garlandContainer)
    return garlandContainer
  }

  addChristmasBranches(garlandContainer) {
    const christmasBranch = document.createElement('div');
    christmasBranch.classList.add('christmas-branch');
    garlandContainer.append(christmasBranch);
    return christmasBranch;
  }

  fillAllParts(christmasBranch) {
    const ballPartsArr = [];

    ballPartsArr.push(this.addBallsPart(christmasBranch))
    const countParts = Math.ceil(christmasBranch.clientWidth / ballPartsArr[0].clientWidth);
    for (let i = 1; i < countParts; i++) {
      ballPartsArr.push(this.addBallsPart(christmasBranch))
    }

    return ballPartsArr
  }

  addBallsPart(christmasBranch) {
    const ballsPart = document.createElement('div');
    ballsPart.classList.add('balls-part')

    const treeContainer = document.createElement('div');
    treeContainer.classList.add('tree-container')
    ballsPart.append(treeContainer)

    this._BELLS_STACK.forEach(item => {
      this.addBalls(ballsPart, item)
    })

    for (let i = 1; i < 7; i++) {
      const tree = document.createElement('div')
      tree.classList.add('tree-branch' + i, 'tree-branch');
      treeContainer.append(tree)
    }

    christmasBranch.append(ballsPart)
    return ballsPart;
  }

  addBalls(container, id) {
    const ball = document.createElement('div')
    ball.classList.add('bell');
    ball.classList.add('bell-' + id);

    const isMinus = !!Math.floor(Math.random() * 2);
    let marginTop;

    if (isMinus) {
      marginTop = -Math.floor(Math.random() * 3)
    } else {
      marginTop = Math.floor(Math.random() * 6) * 2;
    }
    ball.style.marginTop = marginTop + 'px'

    container.append(ball)

    ball.addEventListener('mouseover', () => {
      if (!ball.classList.value.includes('swing')) {
        ball.classList.add('swing');
        setTimeout(() => {
          ball.classList.remove('swing')
        }, 2000)
      }
    })
  }

  addStyles() {
    let css;
    if (document.body.classList.contains('mobile')) {
      css = `.garland-container {
           position: absolute;
          top: 35px;
          width: 100%;
          z-index: 0;
          overflow: hidden;
      }

    .christmas-branch {
      background: url("/themes/jurist/assets/img/christmas/christmas-branches.png");
      width: 100%;
      height: 104px;
      display: flex;
    }

    .christmas-branch:before {
      content: '';
      display: block;
      position: absolute;
      top: -115px;
      left: 0;
      z-index: 3;
      height: 115px;
      width: 100%;
      box-shadow: 0 15px 30px rgb(0 0 0 / 75%);
    }

    .balls-part {
      display: flex;
      position: relative;
    }

    .bell {
      z-index: 2;
    }

    .bell-b {
      background: url("/themes/jurist/assets/img/christmas/bell-b.png");
      width: 56px;
      height: 67px;
    }

    .bell-r {
      background: url("/themes/jurist/assets/img/christmas/bell-r.png");
      width: 49px;
      height: 57px;
    }

    .bell-rl {
      background: url("/themes/jurist/assets/img/christmas/bell-rl.png");
      width: 49px;
      height: 66px;
    }

    .bell-w {
      background: url("/themes/jurist/assets/img/christmas/bell-w.png") no-repeat;
      width: 54px;
      height: 70px;
    }

    .tree-container {
      width: 100%;
      height: 100%;
      position: absolute;
    }

    .balls-part:nth-child(1) > div:nth-child(8) {
      margin-left: 20px;
    }

    .tree-branch {
      position: absolute;
    }

    .tree-branch1 {
      background: url("/themes/jurist/assets/img/christmas/tree-branch1.png");
      width: 25px;
      height: 71px;
      top: 0;
      left: 0;
    }

    .tree-branch2 {
      background: url("/themes/jurist/assets/img/christmas/tree-branch2.png");
      left: 25px;
      width: 61px;
      height: 27px;
    }

    .tree-branch3 {
      background: url("/themes/jurist/assets/img/christmas/tree-branch3.png");
      width: 29px;
      height: 31px;
      left: 170px;
    }

    .tree-branch4 {
      background: url("/themes/jurist/assets/img/christmas/tree-branch4.png");
      width: 51px;
      height: 50px;
      left: 200px;
    }

    .tree-branch5 {
      background: url("/themes/jurist/assets/img/christmas/tree-branch5.png");
      width: 78px;
      height: 28px;
      right: 6px;
    }

    .tree-branch6 {
      background: url("/themes/jurist/assets/img/christmas/tree-branch6.png");
      width: 6px;
      height: 69px;
      right: 0;
    }

    .swing {
      transform-origin: top center;
      animation: swing 2s ease infinite;
    }

    @keyframes swing {
      20% {
        transform: rotate(15deg);
      }
      40% {
        transform: rotate(-10deg);
      }
      60% {
        transform: rotate(5deg);
      }
      80% {
        transform: rotate(-5deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }`
      //  main.container
    } else {
      css = `
    .garland-container {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 3;
  overflow: hidden;
  margin-bottom: -100px;
}

.christmas-branch {
  background: url("/themes/jurist/assets/img/christmas/christmas-branches.png");
  width: 100%;
  height: 104px;
  display: flex;
}

.christmas-branch:before {
  content: '';
  display: block;
  position: absolute;
  top: -115px;
  left: 0;
  z-index: 3;
  height: 115px;
  width: 100%;
  box-shadow: 0 15px 30px rgb(0 0 0 / 75%);
}

.balls-part {
  display: flex;
  position: relative;
}

.bell {
  z-index: 2;
}

.bell-b {
  background: url("/themes/jurist/assets/img/christmas/bell-b.png");
  width: 56px;
  height: 67px;
}

.bell-r {
  background: url("/themes/jurist/assets/img/christmas/bell-r.png");
  width: 49px;
  height: 57px;
}

.bell-rl {
  background: url("/themes/jurist/assets/img/christmas/bell-rl.png");
  width: 49px;
  height: 66px;
}

.bell-w {
  background: url("/themes/jurist/assets/img/christmas/bell-w.png") no-repeat;
  width: 54px;
  height: 70px;
}

.tree-container {
  width: 100%;
  height: 100%;
  position: absolute;
}

.balls-part:nth-child(1) > div:nth-child(8) {
  margin-left: 20px;
}

.tree-branch {
  position: absolute;
}

.tree-branch1 {
  background: url("/themes/jurist/assets/img/christmas/tree-branch1.png");
  width: 25px;
  height: 71px;
  top: 0;
  left: 0;
}

.tree-branch2 {
  background: url("/themes/jurist/assets/img/christmas/tree-branch2.png");
  left: 25px;
  width: 61px;
  height: 27px;
}

.tree-branch3 {
  background: url("/themes/jurist/assets/img/christmas/tree-branch3.png");
  width: 29px;
  height: 31px;
  left: 170px;
}

.tree-branch4 {
  background: url("/themes/jurist/assets/img/christmas/tree-branch4.png");
  width: 51px;
  height: 50px;
  left: 200px;
}

.tree-branch5 {
  background: url("/themes/jurist/assets/img/christmas/tree-branch5.png");
  width: 78px;
  height: 28px;
  right: 6px;
}

.tree-branch6 {
  background: url("/themes/jurist/assets/img/christmas/tree-branch6.png");
  width: 6px;
  height: 69px;
  right: 0;
}

.swing {
  transform-origin: top center;
  animation: swing 2s ease infinite;
}

@keyframes swing {
  20% {
    transform: rotate(15deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
`
    }
    this.fixPages()
    const head = document.head || document.getElementsByTagName('head')[0], styleTag = document.createElement('style');

    head.appendChild(styleTag);

    styleTag.type = 'text/css';
    if (styleTag.styleSheet) {
      // This is required for IE8 and below.
      styleTag.styleSheet.cssText = css;
    } else {
      styleTag.appendChild(document.createTextNode(css));
    }
  }

  fixPages() {
    if (document.body.classList.contains('mobile')) {
      if (!this._isStatuspro || this._page !== 'index') {
        // document.getElementsByClassName('content')[0].childNodes[1].style.marginTop = '120px'
        document.getElementsByClassName('garland-container')[0].style.marginBottom = '-80px'
      }

      if (!this._isStatuspro) {
        if (document.getElementsByClassName('_editors-choice')[0]) document.getElementsByClassName('_editors-choice')[0].style.paddingTop = '90px'
      }


      if (this._page !== 'index' && this._page !== 'landing') {
        document.getElementsByTagName('main')[0].style.marginTop = '115px';
      }

      if (this._page === 'landing') document.getElementsByClassName('subscription-versions')[0].style.paddingTop = '80px';

    } else {

      const headerTop = document.getElementsByClassName('__header-top')[0];
      const dropdown = document.getElementsByClassName('responsive-menu')[0];
      if (dropdown) {
        dropdown.style.zIndex = 4
      }
      if (headerTop) {
        headerTop.style.zIndex = 5;
      }

      if (!this._isStatuspro) {
        if (document.getElementsByClassName('_editors-choice')[0]) document.getElementsByClassName('_editors-choice')[0].style.paddingTop = '90px'
        if (this._page === 'rubric' || this._page === 'journal-rubric' || this._page === 'journal-gms-rubric') document.getElementsByTagName('main')[0].style.marginTop = '40px';
        if (this._page === 'article' || this._page === 'journal-gms-article') document.getElementsByTagName('main')[0].style.marginTop = '90px';
        if (this._page === 'landing') document.getElementsByClassName('subscription-versions')[0].style.paddingTop = '80px';
      }

      if (this._isStatuspro) this.fixStatusproDesktop()

      if (this._page === 'journal-rubric' || this._page === 'journal-article' || this._page === 'journal-number' || this._page === 'journal-home' ||
        this._page === 'journal-gms-rubric' || this._page === 'journal-gms-article') {
        document.getElementsByClassName('garland-container')[0].style.flexShrink = '0'
        document.getElementsByClassName('garland-container')[0].style.marginTop = '0'
      }



      if (this._page === 'journal-home' || this._page === 'wiki-article' || this._page === 'wiki-home' || this._page === 'author_list' || this._page === 'author' || this._page === 'user-profile' ) {
        document.getElementsByClassName('garland-container')[0].style.marginBottom = '0'
      }
    }
  }

  fixStatusproDesktop() {
    // if (this._page === 'article') {
    document.getElementsByClassName('garland-container')[0].style.marginBottom = '-40px'
    // }
    if (this._page === 'tag') {
      this.addBg()
    }
    if (this._page === 'index' || this._page === 'verification') document.getElementsByClassName('garland-container')[0].style.marginBottom = '-80px'

  }

  addBg(bgc = '#f5f7fa', edge = 1) {
    const container = document.getElementsByClassName('garland-container')[0]
    if (container.getBoundingClientRect().top >= edge) {
      container.style.backgroundColor = bgc
    } else {
      container.style.backgroundColor = 'transparent'
    }

    document.addEventListener('scroll', () => {
      if (container.getBoundingClientRect().top >= edge) {
        container.style.backgroundColor = bgc
      } else {
        container.style.backgroundColor = 'transparent'
      }
    })
  }

  addBgMobile(bgc = '#f5f7fa',) {
    const container = document.getElementsByClassName('garland-container')[0]
    if (window.scrollY <= 139) {
      container.style.backgroundColor = bgc
    } else {
      container.style.backgroundColor = 'transparent'
    }
    document.addEventListener('scroll', () => {
      if (window.scrollY <= 139) {
        container.style.backgroundColor = bgc
      } else {
        container.style.backgroundColor = 'transparent'
      }
    })
  }
}

export default new Balls();
